import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';

export function getAssistentConfigCO2(customCfg?: AssistentItem): AssistentItem {
    return {
        gliederung: '4.',
        name: 'Technische Gase/Kältemittel',
        description: 'Dies ist das Formular zur Eingabe der Technische Gase/Kältemittel-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_KLIMAGASE,
        configFlag: 'inputCO2',
        addLabel: 'Weitere klimawirksame Gase hinzufügen',
        customCssStyle: { formcontainer: { minHeight: 372 } },
        ...(customCfg || {})
    };
}
